/* istanbul ignore file */
import React from 'react';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import InvoiceBreadcrumbs from 'domain/finance/invoice/shared/InvoiceBreadcrumbs';

const CreateInvoiceBreadcrumbs = () => {
  return (
    <InvoiceBreadcrumbs>
      <CreateBreadcrumbItem entity="Invoice" />
    </InvoiceBreadcrumbs>
  );
};

export default CreateInvoiceBreadcrumbs;
